import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private sharedData: any = [];
  constructor() { }

  setData(data: any) {
    this.sharedData = data;
  }

  getAllData() {
    return this.sharedData;
  }

  getDataById(id: number) {
    const filteredData = this.sharedData.find((res: any) => res.hierarchyMetadataId === id)?.hierarchyName;
    return filteredData;
  }

  getLabelByName(name: string) {

    let nameToReturn = ''
    let arry = name.split('&');

    if (arry.length > 1) {
      for (let i = 0; i < arry.length; i++) {
        const filteredData = this.sharedData.find((res: any) => res.hierarchyName === arry[i].trim())?.hierarchyName;
        nameToReturn = nameToReturn.concat(filteredData, ' & ');
      }
      nameToReturn = nameToReturn.slice(0, -3) // remove last &
    }
    else {
      nameToReturn = name
    }
    return nameToReturn;
  }
}
